import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=2588d1b0&"
import script from "./Metrics.vue?vue&type=script&lang=ts&"
export * from "./Metrics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2588d1b0')) {
      api.createRecord('2588d1b0', component.options)
    } else {
      api.reload('2588d1b0', component.options)
    }
    module.hot.accept("./Metrics.vue?vue&type=template&id=2588d1b0&", function () {
      api.rerender('2588d1b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/QA/Metrics.vue"
export default component.exports